import React, { useState, useEffect } from 'react';
import headerLogo from 'assets/images/logos/rootstoken__white.png';
import Menu from 'components/ui/menu';
import ActionButton from 'components/ui/buttons/action-button';
import { IoMdMenu } from 'react-icons/io';
import { useAppDispatch } from 'reduxStore/hooks';
import { Link } from 'react-router-dom';
import { setDisplayMobileMenu } from 'reduxStore/slices/contact.slice';
import SocialComponent from 'components/ui/social';
import Animated from 'components/generals/AnimatedComponent';

export default function MainHeader() {
    const dispatch = useAppDispatch();
    const [scrolled, setScrolled] = useState(false);
    const handleScroll = () => {
        const offset = window.scrollY;
        if (offset > 0) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const menuClasses = [''];
    if (scrolled) {
        menuClasses.push('scrolled transition');
    }

    return (
        <>
            <header className={`nv__header ${menuClasses.join(' ')}`}>
                <section className="nv__header__container">
                    <div className="nv__header__logo">
                        <Animated animation={'animate__fadeInDown logo-absolute'}>
                            <Link to="/#home">
                                <img src={headerLogo} alt="Logo SSD" />
                            </Link>
                        </Animated>
                    </div>

                    <Animated animation={'animate__fadeInDown header-menu'}>
                        <Menu />
                    </Animated>
                    <Animated animation={'animate__fadeInDown'}>
                        <section className="nv__header__button__section">
                            <div
                                className="nv__header__menu nv__header__menu--mobile"
                                onClick={() => {
                                    dispatch(setDisplayMobileMenu(true));
                                }}
                            >
                                <IoMdMenu />
                            </div>

                            <SocialComponent />
                        </section>
                    </Animated>
                </section>
            </header>
        </>
    );
}
